<h4>
  @if (messageType() === 'invite') {
    You are welcome to join our affiliate program!
  } @else {
    We have updated our affiliate program terms.
  }
</h4>
<p>
  <button type="button" class="btn btn-success" (click)="reviewAffiliateTNC()">
    @if (messageType() === 'invite') {
      Learn More
    } @else {
      Review
    }
  </button>
  &nbsp;&nbsp;&nbsp;
  <button type="button" class="btn btn-secondary" (click)="dismiss(false)">Remind me later</button>
  &nbsp;&nbsp;&nbsp;
  <button type="button" class="btn btn-secondary" (click)="dismiss(true)">Ignore</button>
</p>
@if (messageType() === 're-tnc') {
  <p><strong>Please note:</strong> Your pending balance may be put on hold until you accept the updated terms and conditions.</p>
}
